<template>
    <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true" ref="modal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title flex-grow-1">{{ title }}</h5>
            <button 
            type="button" 
            class="btn-close" 
            data-bs-dismiss="modal" 
            aria-label="Close"
            @click="closeDialog"
          ></button>          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
       
            <slot name="footer">
              <button 
                type="button" 
                class="btn btn-primary"
                @click="handleConfirm"
                :disabled="loading"
              >
                <span v-if="loading">              <i class="fas fa-spinner fa-spin me-2"></i>
</span>   
              {{ confirmText || $t('baseDialog.save') }}
              </button>
              <button 
              type="button" 
              class="btn btn-outline-secondary" 
              data-bs-dismiss="modal"
              @click="closeDialog"
              :disabled="loading"
            >
              {{ $t('baseDialog.cancel') }}
            </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, defineEmits, defineProps, defineExpose } from 'vue';
  import { Modal } from 'bootstrap';
  
  defineProps({
    modalId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: 'حفظ'
    },
    loading: {
      type: Boolean,
      default: false
    }
  });
  
  const emit = defineEmits(['confirm', 'close']);
  
  const modal = ref(null);
  let bsModal = null;
  
  onMounted(() => {
    bsModal = new Modal(modal.value);
  
  modal.value.addEventListener('hidden.bs.modal', () => {
    emit('close');
  });
});
  const openDialog = () => {
    bsModal.show();
  };
  
  const closeDialog = () => {
    bsModal.hide();
    emit('close');
  };
  
  const handleConfirm = () => {
    emit('confirm');
  };
  
  defineExpose({ openDialog, closeDialog });
  </script>